import sharedFilters from './shared';

export default {
  pageFilters: [
    {
      id: 'content',
      label: 'Content',
      filters: {
        movie: {
          boolean: 'OR',
          booleanSeparator: 'OR',
          value: null
        },
        studio: null,
        genre: null,
        originating_country: sharedFilters.originating_country
      }
    },
    {
      id: 'users',
      label: 'Users',
      filters: {
        country: null,
        panel: sharedFilters.sampleBalance,
        age: null,
        gender: null
      }
    },
    {
      id: 'date',
      label: 'Date',
      filters: {
        date: null
      }
    },
    {
      id: 'metric',
      label: 'Metric',
      filters: {
        metric: null
      }
    },
    {
      id: 'segments',
      label: 'Saved Filters',
      filters: {
        segments: sharedFilters.segments
      }
    }
  ],
  queries: {
    movieAffinityOR: {
      fields: [
        'movie',
        'studio',
        'genre',
        'country',
        'panel',
        'age',
        'gender',
        'date',
        'metric',
        'originating_country'
      ]
    },
    movieAffinityAND: {
      fields: [
        'movie',
        'studio',
        'genre',
        'country',
        'panel',
        'age',
        'gender',
        'date',
        'metric',
        'originating_country'
      ]
    },
    movieCountryIndex: {
      fields: ['movie', 'date', 'age', 'gender', 'affinityType', 'countryDemo']
    },
    movieAgeIndex: {
      fields: [
        'movie',
        'date',
        'country',
        'panel',
        'gender',
        'affinityType',
        'ageDemo'
      ]
    },
    movieGenderIndex: {
      fields: [
        'movie',
        'date',
        'country',
        'panel',
        'age',
        'affinityType',
        'genderDemo'
      ]
    }
  }
};
